/* src/app/main-graph/main-graph.component.css */
#containerMain {
  height: 60rem;
  width: 100%;
}
#legendItemsLive {
  font-size: medium;
  text-align: left;
}
.legendRed {
  color: #EE4B2B;
}
.legendGreen {
  color: green;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #containerMain {
    height: 50rem;
  }
}
#legendLive {
  margin-left: 0rem;
  padding-left: 1rem;
  color: white;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #legendLive {
    margin-left: 0rem;
    padding-left: 1rem;
    color: white;
  }
}
.legendGrad {
  background-image:
    linear-gradient(
      to right,
      #BACEE7,
      #ACC0E1,
      white);
}
.legendShadow {
  box-shadow: 1px 2px 14px rgba(0, 0, 0, .5);
}
.legendRed {
  color: #EE4B2B;
}
.legendGreen {
  color: green;
}
#legendItemsLive {
  width: 100%;
}
#containerMain {
  height: 75rem;
  width: 100%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  #containerMain {
    height: 50rem;
  }
}
.brochurePos {
  margin-left: 0rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .brochurePos {
    margin-left: 2.5rem;
  }
}
#about {
}
.nsdqChart {
  width: 840px;
  height: 680px;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .nsdqChart {
    width: 100%;
    height: 280px;
  }
  .highcharts-legend {
    pointer-events: none;
  }
}
.chart .chart__head {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  display: block;
}
.hide {
  display: none;
}
/*# sourceMappingURL=main-graph.component.css.map */
